export const STATUS_LABELS: { [storedValue: string]: string } = {
	'Member Review': 'Ready for Review',
	'Member Review (Re-sent)': 'Ready for Review (Re-sent)',
};

export function statusLabel(status: string): string {
	return STATUS_LABELS[status] || status;
}
